const WorklogStatusStackedChart = (rawData = []) => {
  if (!rawData?.length) return {};

  // Step 1: Collect all status types and their colors
  const statusMetaMap = {}; // { [statusName]: { color: '#hex' } }

  const formattedData = rawData.map(entry => {
    const name = `${entry.profile.firstName} ${entry.profile.lastName}`;
    const userItem = { name };

    entry.statusCounts.forEach(status => {
      userItem[status.name] = status.count;

      // Store color for each status
      if (!statusMetaMap[status.name]) {
        statusMetaMap[status.name] = { color: status.color || '#ccc' };
      }
    });

    return userItem;
  });

  const statusKeys = Object.keys(statusMetaMap);
  const useDataZoom = formattedData.length > 15;

  return {
    color: statusKeys.map(key => statusMetaMap[key].color),
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        if (!params?.length) return '';
        const index = params[0]?.dataIndex ?? 0;
        const fullName = formattedData[index]?.name || '—';
        const statusLines = params
          .map(p => `${p.marker} ${p.seriesName}: ${p.value}`)
          .join('<br/>');
        return `<b>${fullName}</b><br/>${statusLines}`;
      }
    },
    legend: {
      show: false
    },
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 5 : 5,
      top: 30,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: formattedData.map(d => d.name.split(' ').map(n => n[0]).join('').toUpperCase())
    },
    yAxis: {
      type: 'value',
      name: 'Tickets'
    },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 40
        },
        {
          type: 'slider',
          show: false,
          xAxisIndex: 0,
          height: 15,
          bottom: 40
        }
      ]
      : [],
    series: statusKeys.map((key, index) => ({
      name: key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase()),
      type: 'bar',
      stack: 'status',
      data: formattedData.map((user, i) => {
        const value = user[key] || 0;
        return {
          value,
          itemStyle: {
            color: value === 0 ? 'transparent' : statusMetaMap[key]?.color || '#ccc',
            borderRadius: index === statusKeys.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]
          }
        };
      }),
      emphasis: {
        focus: 'series'
      }
    }))

  };
};

export default WorklogStatusStackedChart;
